import React from 'react';
import {useTranslation} from 'react-i18next';
import {Link, NavLink} from 'react-router-dom';
import {HelpIcon, MenuIcon} from 'styles/components/Icons';
import {StyledNav, StyledNavItem} from 'styles/components/Nav.styles';
import {generateHtmlId} from 'mrf/utils/StringGenerators';
import Hidden from 'styles/basic/Hidden';
import usePrintMode from 'mrf/utils/usePrintMode';
import UserDropdown from 'mrf/view/user/UserDropdown';
import Flex from 'mrf/layout/Flex';
import IFAuth from 'mrf/view/IFAuth';


//TODO: [CDI-393] Refactor to encapsulate styles and components
export default function NavMenu({navLinks}) {
    
    const printMode = usePrintMode();
    const {t} = useTranslation();

    if (printMode) {
        return false;
    }

    return (
        <StyledNav>
            <div className='logo'>
                <figure>
                    <img
                        src={process.env.PUBLIC_URL + '/oas_logo.png'}
                        className='h-10'
                        height='40'
                        alt='logo'
                    />
                </figure>
            </div>
            <label htmlFor='menu-toggle' className='menu-icon'>
                <MenuIcon size={36}/>
            </label>
            <Hidden as='input' type='checkbox' id='menu-toggle'/>
            <ul id='menu'>
                <div className='nav-items'>
                    {navLinks.map((link, i) => (
                        <IFAuth // nav item is only displayed if no roleCodes list is passed OR if the user has the required roles
                            key={i}
                            roleCodes={link?.roleCodes}
                        >
                            <StyledNavItem>
                                <NavLink
                                    className='nav-link'
                                    activeClassName='nav-active'
                                    to={link.path}
                                    id={generateHtmlId('navlink', link.name)}
                                >
                                    {t(link.name)}
                                    <div className='nav-bottom-line'/>
                                </NavLink>
                            </StyledNavItem>
                        </IFAuth>
                    ))}
                </div>
                <div className='nav-action'>
                    <Flex className='items-center'>
                            <Link to='/help'>
                                <HelpIcon
                                    className='nav-icon'
                                    size='30'
                                    title={t('Help')}
                                />
                            </Link>
                        <UserDropdown/>
                    </Flex>
                </div>
            </ul>
        </StyledNav>
    );
}
